import React, { useState, useCallback } from "react";
import { RxCross2 } from "react-icons/rx";
import { useSubscribeDataMutation } from "./Subcribemodelapislice";
import { useSearchUserQuery } from "../../Admin/adminApiSlice";
import { debounce } from "lodash";
import SelectBox from "../../reduxworkbook/components/Aside2Components/DropzoneComponents/FilterConfigCompComponents/SelectBox";
import useAuth from "../../../hooks/useAuth";

const days = [
  { day: "Mon" },
  { day: "Tue" },
  { day: "Wed" },
  { day: "Thu" },
  { day: "Fri" },
  { day: "Sat" },
  { day: "Sun" },
];
const timeZones = [
  { label: "Daily", value: "daily" },
  { label: "Weekly", value: "weekly" },
  { label: "Monthly", value: "monthly" },
];
function getDatesForCurrentMonth() {
  const now = new Date();
  // console.log(now);
  const today = now.getDate();
  const year = now.getFullYear();
  const month = now.getMonth(); // 0-indexed: January is 0, February is 1, etc.

  // Get last day of the current month
  const lastDay = new Date(year, month + 1, 0).getDate();

  // Create array of dates from 1 to lastDay
  const dates = Array.from({ length: lastDay }, (_, i) => i + 1);
  // Format time to 24-hour HH:MM
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const time = `${hours}:${minutes}`;
  // console.log(time);

  return {
    today,
    dateArray: dates.map((item) => {
      return { label: item, value: item };
    }),
    time,
  };
}
function getUTCString(day, time) {
  // console.log(day);
  // console.log(time);
  const [hours, minutes] = time.split(":").map(Number);

  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth(); // 0-based, so Jan = 0, Apr = 3

  // Construct date from year, month, and passed day/time
  const date = new Date(year, month, day, hours, minutes);

  if (isNaN(date)) {
    throw new Error("Invalid date or time input");
  }

  return date.toISOString();
}

export default function SubscribeModal({
  closeModal,
  sheetId,
  workbookId,
  currentSheetType,
}) {
  const { username } = useAuth();
  const [searchQuery, setSearchQuery] = useState("");

  const [formData, setFormData] = useState({
    username: username,
    subscribeUsers: [username],
    subject: "",
    repeats: timeZones[0].value,
    time: getDatesForCurrentMonth()["time"],
    format: "image",
    selectedSheetId: sheetId,
    workbookId: workbookId,
    sheetType: currentSheetType,
    on: null,
  });
  const [selectedDate, setSelectedDate] = useState(
    getDatesForCurrentMonth()["today"]
  );
  const [selectedValue, setSelectedValue] = useState(timeZones[0].value);
  // Mutation hook for subscribing data
  const [
    subscribeData,
    {
      isLoading: isSubscribing,
      isSuccess: isSubscribeSuccess,
      isError: isSubscribeError,
    },
  ] = useSubscribeDataMutation();

  const {
    data: searchedUsersData,
    isLoading: isSearchedUsersLoading,
    isError: isSearchedUsersError,
    isSuccess: isSearchedUsersSuccess,
    error: searchedUserError,
  } = useSearchUserQuery(searchQuery, {
    skip: searchQuery.length === 0, // Skip fetching if search query is empty
  });
  const debouncedSearch = useCallback(
    debounce((query) => {
      setSearchQuery(query);
    }, 300),
    []
  );
  const handleInputChange = (e) => {
    const query = e.target.value;
    // console.log(query);
    debouncedSearch(query);
  };
  if (isSearchedUsersLoading) {
    // console.log("loading");
  }
  if (isSearchedUsersError) {
    // console.log(searchedUserError);
  }
  if (isSearchedUsersSuccess) {
    // console.log(searchedUsersData);
  }

  const handleDayClick = (day) => {
    if (selectedValue === "weekly") {
      setFormData((prevData) => ({
        ...prevData,
        on: prevData.on === day ? "" : day,
      }));
    }
  };
  const handleValueChange = (e) => {
    const selected = timeZones.find((item) => item.value === e.target.value);
    if (selected) {
      setSelectedValue(selected.value);
      setFormData({ ...formData, repeats: selected.value });
    }
  };
  const handleDateChange = (e) => {
    if (e.target.value) {
      setSelectedDate(e.target.value);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let subscribeReq = formData;
    if (subscribeReq.repeats === "monthly") {
      const utcString = getUTCString(selectedDate, subscribeReq.time);
      subscribeReq = { ...formData, time: utcString, on: null };
    }
    // console.log(subscribeReq);
    // subscribeData(subscribeReq);
  };

  return (
    <main
      className="fixed inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center z-20"
      // onKeyDown={handleKeyDown}
    >
      <main className="bg-white w-96 border rounded-lg shadow-lg p-1">
        <header className="flex justify-between items-center p-1 border-b">
          <h2 className="text-lg font-medium">Subscribe</h2>
          <RxCross2
            onClick={closeModal}
            className="cursor-pointer text-black"
          />
        </header>
        <form
          className="w-full flex flex-col items-center justify-center p-1 gap-3"
          onSubmit={handleSubmit}
        >
          <div className="flex flex-col items-start justify-start w-full relative">
            <label className="font-medium text-black">Subscribe users:</label>
            <input
              type="text"
              onChange={(e) => handleInputChange(e)}
              className="p-[3px] border rounded w-full focus:outline-none"
              autoComplete="off"
              placeholder="search users..."
            />
            {searchQuery !== "" &&
            Array.isArray(searchedUsersData) &&
            searchedUsersData.length ? (
              <div className="flex flex-col w-full absolute top-full max-h-40 overflow-y-auto overflow-hidden border rounded items-start px-1 bg-white z-10">
                {searchedUsersData.map((user) => {
                  return (
                    <button
                      className="hover:bg-gray-100 w-full p-[2px] flex justify-start items-center"
                      onClick={() => {
                        setFormData((prev) => ({
                          ...prev,
                          subscribeUsers: [
                            ...prev.subscribeUsers,
                            user.username,
                          ],
                        }));
                        setSearchQuery(""); // clear search input
                      }}
                    >
                      {user.username}
                    </button>
                  );
                })}
              </div>
            ) : null}
            <div className="flex flex-wrap gap-2 mt-2">
              {formData.subscribeUsers.map((user, idx) => (
                <span
                  key={idx}
                  className="bg-blue-950 text-white px-2 py-1 rounded flex items-center gap-1"
                >
                  {user}
                  <RxCross2
                    className="cursor-pointer"
                    onClick={() => {
                      setFormData((prev) => ({
                        ...prev,
                        subscribeUsers: prev.subscribeUsers.filter(
                          (u) => u !== user
                        ),
                      }));
                    }}
                  />
                </span>
              ))}
            </div>
          </div>

          <div className="flex flex-col items-start justify-start w-full">
            <label className="font-medium text-black">Subject:</label>
            <input
              type="text"
              name="subject"
              value={formData.subject}
              onChange={(e) =>
                setFormData({ ...formData, subject: e.target.value })
              }
              placeholder="eg. Monthly sales"
              className="p-[3px] border rounded w-full focus:outline-none"
            />
          </div>

          <div className="flex flex-wrap w-full gap-3">
            <div className="w-full flex items-center justify-start gap-2">
              <div className="w-[50%] flex flex-col items-start justify-center">
                <label className="font-medium text-black">Repeats</label>
                <SelectBox
                  value={selectedValue}
                  onChange={handleValueChange}
                  optionsArray={timeZones}
                />
              </div>

              {selectedValue !== "monthly" ? (
                <div className="w-[50%] flex flex-col items-start justify-center">
                  <label className="font-medium text-black">At</label>
                  <input
                    type="time"
                    name="at"
                    value={formData.time}
                    onChange={(e) =>
                      setFormData({ ...formData, time: e.target.value })
                    }
                    className="w-full p-[6px] border rounded shadow-sm focus:outline-none focus:ring-2"
                  />
                </div>
              ) : (
                <div className="w-full flex flex-col sm:flex-row items-center justify-between gap-2">
                  <div className="w-full sm:w-[48%] flex flex-col items-start justify-center">
                    <label className="font-medium text-black">Date</label>
                    <SelectBox
                      value={selectedDate}
                      onChange={handleDateChange}
                      optionsArray={getDatesForCurrentMonth()["dateArray"]}
                      isArrayBig={
                        getDatesForCurrentMonth()["dateArray"].length > 6
                      }
                    />
                  </div>
                  <div className="w-full sm:w-[48%] flex flex-col items-start justify-center">
                    <label className="font-medium text-black">At</label>
                    <input
                      type="time"
                      name="at"
                      value={formData.time}
                      onChange={(e) =>
                        setFormData({ ...formData, time: e.target.value })
                      }
                      className="w-full p-[6px] border rounded shadow-sm focus:outline-none focus:ring-2"
                    />
                  </div>
                </div>
              )}
            </div>

            {selectedValue === "weekly" ? (
              <div className="w-full flex items-center justify-start gap-2">
                <label className="font-medium text-black">On</label>
                {days.map((item, index) => (
                  <span
                    key={index}
                    className={`cursor-pointer border rounded w-10 h-7 text-center font-light ${
                      formData.on === item.day
                        ? "bg-blue-950 text-white"
                        : "bg-gray-200"
                    }`}
                    onClick={() => handleDayClick(item.day)}
                  >
                    {item.day}
                  </span>
                ))}
              </div>
            ) : null}
          </div>

          <div className="flex w-full items-center justify-start gap-2">
            <label className="font-medium text-black">Format:</label>
            <div className="flex items-center gap-2 ">
              <input
                id="Image"
                name="format"
                type="radio"
                value="Image"
                checked={formData.format === "image"}
                onChange={(e) =>
                  setFormData({ ...formData, format: e.target.value })
                }
                className="h-4 w-4 text-blue-600 border-gray-300"
              />
              <label htmlFor="Image" className="font-light text-black">
                Image
              </label>
              <input
                id="Pdf"
                name="format"
                type="radio"
                value="PDF"
                checked={formData.format === "PDF"}
                onChange={(e) =>
                  setFormData({ ...formData, format: e.target.value })
                }
                className="h-4 w-4 text-blue-600 border-gray-300"
              />
              <label htmlFor="Pdf" className="font-light text-black">
                PDF
              </label>
            </div>
          </div>

          <div className="w-full flex items-center justify-end gap-4">
            <button
              type="button"
              onClick={closeModal}
              className="px-4 py-2 border border-gray-200 rounded-md text-black"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-950 text-white rounded-md"
              disabled={isSubscribing}
            >
              {isSubscribing ? "Subscribing..." : "schedule"}
            </button>
          </div>

          {isSubscribeError && (
            <div className="text-red-500 mt-2">
              Subscription failed. Please try again.
            </div>
          )}
          {isSubscribeSuccess && (
            <div className="text-green-500 mt-2">Subscription successful!</div>
          )}
        </form>
      </main>
    </main>
  );
}
